// Powiadomienia (45-B / 46-A, paczka PW; KONTRAKTY 2026-09-24): ekran /powiadomienia, dzwonek,
// przełączniki e-maili w Ustawieniach. Zdania `kind.<rodzaj>` składa się WYŁĄCZNIE z ładunku
// wiersza; te same zdania (gettext) niosą maile z `app/translations`. Klucze PL i EN równocześnie.
export const appNotifications = {
  title: 'Powiadomienia',
  empty: 'Brak powiadomień',
  // Kropka nowego wiersza: nazwa tylko dla czytnika (reguła 5).
  unread: 'nowe',
  emailTag: 'e-mail',
  loadMore: 'Załaduj więcej',
  errorTitle: 'Nie udało się wczytać powiadomień.',
  retry: 'Spróbuj ponownie',
  kind: {
    own_schedule_running_out: 'Na koncie {handle} zostały posty do {date}.',
    plan_finished: 'Plan „{name}” zakończony.',
    monthly_summary: 'Obejrzenia {inMonth}: {total}.',
    milestone_reached: '{threshold} obejrzeń pod „{track}”.',
  },
  action: {
    own_schedule_running_out: 'Zaplanuj',
    plan_finished: 'Pokaż plan',
    monthly_summary: 'Pokaż statystyki',
    milestone_reached: 'Pokaż',
  },
  // Karta miesiąca w wierszu (46-A 03, reguła 64): cztery dane, bez zdań.
  month: {
    record: 'najlepszy miesiąc do tej pory',
    topTrack: 'Najczęściej oglądany utwór',
    topValue: '„{track}”',
    nextRing: 'Do {threshold} pod „{track}”',
    left: 'zostało {left}',
  },
  // Porównanie z poprzednim miesiącem: dopełniacz z przyimkiem („wobec lipca”), nie „vs lipiec”.
  monthVs: {
    m1: 'wobec stycznia', m2: 'wobec lutego', m3: 'wobec marca', m4: 'wobec kwietnia', m5: 'wobec maja', m6: 'wobec czerwca',
    m7: 'wobec lipca', m8: 'wobec sierpnia', m9: 'wobec września', m10: 'wobec października', m11: 'wobec listopada', m12: 'wobec grudnia',
  },
  // Miejscownik z przyimkiem; mianownik daje Intl.
  monthIn: {
    m1: 'w styczniu', m2: 'w lutym', m3: 'w marcu', m4: 'w kwietniu', m5: 'w maju', m6: 'w czerwcu',
    m7: 'w lipcu', m8: 'w sierpniu', m9: 'we wrześniu', m10: 'w październiku', m11: 'w listopadzie', m12: 'w grudniu',
  },
  today: 'dziś',
  yesterday: 'wczoraj',
  // Ustawienia › Powiadomienia e-mail: etykieta = rodzaj, bez zdań.
  settings: {
    heading: 'Powiadomienia e-mail',
    own_schedule_running_out: 'Koniec własnego harmonogramu',
    plan_finished: 'Plan zakończony',
    monthly_summary: 'Podsumowanie miesiąca',
    milestone_reached: 'Progi utworów',
  },
}
